import { useQuery } from '@tanstack/react-query';
import { Metadata_Service } from '.';
import {
  ListWorkflowsResponse,
  GetWorkflowHistoryRequest,
  GetWorkflowHistoryResponse,
  ListWorkflowsRequest,
  DateTimeRange,
} from '../types/tecton_proto/metadataservice/metadata_service';
import IdUtils from '../utils/id-utils';
import { WorkflowType } from 'src/types/tecton_proto/workflows/workflow';

const fetchListWorkflows = async (payload: ListWorkflowsRequest): Promise<ListWorkflowsResponse> => {
  const response = await Metadata_Service.post('list-workflows', payload);
  return response.data;
};

export const useWorkflows = (request: ListWorkflowsRequest, keepPreviousData = false) => {
  return useQuery(
    ['listWorkflows', request],
    () => {
      return fetchListWorkflows(request);
    },
    { keepPreviousData }
  );
};

const fetchWorkflowHistory = async (payload: GetWorkflowHistoryRequest): Promise<GetWorkflowHistoryResponse> => {
  const response = await Metadata_Service.post('get-workflow-history', payload);
  return response.data;
};

export const useWorkflowHistory = (workflow_id: string) => {
  return useQuery(['workflowHistory', workflow_id], () => {
    return fetchWorkflowHistory({
      id: IdUtils.fromStringId(workflow_id),
      page_size: 100,
    });
  });
};
